import React from 'react';
import SingleValueIcon from '@splunk/dashboard-visualizations/SingleValueIcon';

export default () => (
    <SingleValueIcon
        options={{}}
        encoding={{
            trend: 'primary.foo',
            fill: {
                field: 'primary[0][2]',
                format: {
                    type: 'rangevalue',
                    ranges: [
                        {
                            from: 100,
                            value: '#A52A2A',
                        },
                        {
                            from: 40,
                            to: 100,
                            value: '#FFA500',
                        },
                        {
                            from: 13,
                            to: 40,
                            value: '#FFFF00',
                        },
                        {
                            from: 1,
                            to: 13,
                            value: '#800080',
                        },
                        {
                            from: 0,
                            to: 1,
                            value: '#0000FF',
                        },
                        {
                            to: 0,
                            value: '#000000',
                        },
                    ],
                },
            },
        }}
        dataSources={{
            primary: {
                data: {
                    columns: [
                        ['1', '62', '103', '308', '587', '876', '930', '1320'],
                        [
                            '#FF0000',
                            '#00FFFF',
                            '#0000FF',
                            '#800080',
                            '#FFFF00',
                            '#FFA500',
                            '#A52A2A',
                            '#008000',
                        ],
                    ],
                    fields: [
                        {
                            name: 'foo',
                        },
                        {
                            name: 'bar',
                        },
                    ],
                },
                meta: {},
            },
        }}
    />
);
